import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { gsap } from 'gsap';
import { throttle } from 'throttle-debounce';

import { $Elements, Breakpoints, BrowserEvents, Classes, Elements, TransitionDurations } from './constants';

export const calculateMenuOffset = (target) => target.offset().top - $Elements.HeaderWrapper.height();

;(function($) {

	$Elements.document.on(BrowserEvents.page.loaded, () => {

		// ---------- Scroll To Anchor ----------

		const linkTarget = window.location.href;
		const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

		if(sectionTarget.substring(0, 1) === '#') {

			const section = $(sectionTarget);

			if(section.length) {

				$('html, body').stop().animate({
					scrollTop: calculateMenuOffset(section)
				}, 1);
			}
		}

		// ---------- Menu ----------

		$('.menu-toggle, a[href="#menu-wrapper"]').click(function(e) {
			e.preventDefault();

			if($Elements.body.hasClass(Classes.menuOpen)) {
				$Elements.body.removeClass(Classes.menuOpen);
				enableBodyScroll(Elements.MenuWrapper);
			}
			else {
				const active = $Elements.MenuWrapper.find('.main-menu li[data-menu="' + Elements.PageWrapper.dataset.activeMenu + '"]').last();

				if(active.hasClass('submenu-item') && !$Elements.MenuWrapper.find('.menu-image.active').length) {

					const image = active.prevAll('.menu-item').first().data('menu');
					$Elements.MenuWrapper.find('.menu-image[data-menu="' + image + '"]').addClass(Classes.active);
				}

				active.trigger('mouseenter');
				$Elements.body.addClass(Classes.menuOpen);
				disableBodyScroll(Elements.MenuWrapper);
			}
		});

		$Elements.MenuWrapper.each(function() {

			const images = $(this).find('.menu-images');
			const menuImages = images.find('.menu-image');
			const links = $(this).find('.menu-links');
			const menuItems = links.find('.menu-item');
			const subMenuItems = links.find('.submenu-item');

			menuItems.on('mouseenter touchstart', throttle(TransitionDurations.default, false, async function() {
				Elements.MainWrapper.dataset.activeMenu = this.dataset.menu;
				Elements.MainWrapper.dataset.activeColor = this.dataset.color;

				menuItems.removeClass(Classes.active);
				this.classList.add(Classes.active);

				const leaving = images.find('.' + Classes.active);
				const active = images.find('.menu-image[data-menu="' + this.dataset.menu + '"]');

				if(leaving.length && active.length && !leaving[0].isSameNode(active[0])) {

					leaving.removeClass(Classes.active);
					active.addClass(Classes.active);

					if(window.innerWidth >= Breakpoints.Menu) {
						gsap.set(leaving, { zIndex: 2 });
						gsap.set(active, { zIndex: 3 });

						gsap.fromTo(active.find('.image-wrapper'), { y: '100%' }, { y: 0, duration: TransitionDurations.default * 0.001, ease: "power2.out" });
						await gsap.fromTo(active.find('.image'), { y: '-100%' }, { y: 0, duration: TransitionDurations.default * 0.001, ease: "power2.out" });

						gsap.set(leaving, { zIndex: 1 });
					}
				}
			}));

			subMenuItems.each(function() {
				$(this).on('mouseenter touchstart', () => $(this).prevAll('.menu-item').first().trigger('mouseenter'));
			});
		});
	});

}(jQuery));
